import React, {useEffect, useState} from 'react';
import { Form } from 'react-final-form';
import { Row, Col, Container, Card, CardBody, Button } from 'reactstrap';
import { connect } from 'react-redux'
import { withRouter, useParams } from 'react-router-dom'
import axios from 'axios';
import { useDispatch, flashError, flashSuccess } from "@/shared/components/flash"
import Select from 'react-select';
import { Field } from 'react-final-form';
import FormStep1 from './FormStep1';
import UploadModal from './UploadModal';
import FormStep2 from './FormStep2';

const isValidResponse = data => {
  if (!data.hasOwnProperty('CSVheaders')) return false;
  if (!data.hasOwnProperty('fieldsToMap')) return false;
  // Add more validation here
  return true;
}

const tableConfig = {
  isResizable: true,
  isSortable: false
}

let config = {
  importType: {
    name: 'import_type',
    label: 'Select Import Type',
    options: [
      {
        label: 'Events',
        value: 'Events'
      },
      {
        label: 'Programs',
        value: 'Programs'
      },
      {
        label: 'Users',
        value: 'Users'
      },

    ],
    // placeholder: null
  },
  importFile: {
    name: 'import_file',
    label: 'Choose File'
  },
  importTypeStep2: {
    name: 'import_type',
    label: 'Select Import Type',
    options: [
      {
        label: 'Users',
        value: 'Users'
      }
    ],
    placeholder: ' ----- '
  },
  userRole: {
    name: 'user_role',
    label: 'Select User Role',
    options: [
      {
        label: 'Participant',
        value: 'Participant'
      },
      {
        label: 'Manager',
        value: 'Manager'
      }
    ],
    placeholder: ' ----- '
  }
}

const ImportForm = ({ organization, theme, rtl }) => {
  const dispatch = useDispatch()
  const [importType, setImportType] = useState('');
  const [importHeaders, setImportHeaders] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [step, setStep] = useState(0);
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [roles, setRoles] = useState(null)
  const [saveSettings, setSaveSettings] = useState(false);
  const [csvImportSettingId, setCsvImportSettingId] = useState(false);
  const [rootPrograms, setRootPrograms] = useState([]);
  const [rootProgramId, setRootProgramId] = useState(null);
  const [isUploadModalOpen, setUploadModalOpen] = useState(false);
  const [configForUpload, setConfigForUpload] = useState(null);

  const { id } = useParams();

useEffect(() => {
  if (organization?.id) {
    axios.get(`/organization/${organization.id}/root-programs`)
      .then(res => {
        setRootPrograms((res.data?.data || []).map(p => ({ value: p.id, label: p.name })));
      });
  }
}, [organization?.id]);

useEffect(() => {
  if (id && organization?.id) {
    // Load full config for UploadModal and root_program_id
    axios.get(`/organization/${organization.id}/csv-import-setting/${id}/show`)
      .then((res) => {
        setConfigForUpload(res.data);
        setImportHeaders(prev => ({
          ...prev,
          name: res.data.name
        }));
        if (res.data.root_program_id) {
          setRootProgramId(res.data.root_program_id);
        }
      });

    // headers + file + step
    axios.get(`/organization/${organization.id}/csv-import-setting/${id}`)
      .then((res) => {
        setImportHeaders(prev => ({
          ...prev,
          ...res.data
        }));

        setCsvFile(new Blob([res.data.csvfile || ""], { type: "text/csv" }));
        if (res.data.root_program_id) {
          setRootProgramId(res.data.root_program_id);
        }
        setStep(2);
      });

  }
}, [id, organization?.id]);

  const reset = () => {
    setStep(0)
    setCsvFile(null)
    setImportHeaders(null)
    setImportType('')
    setError(null)
    setLoading(false)
    setSaveSettings(false)
  }

  const onSelectCsvFile = (file) => {
    setCsvFile(file)
    setImportHeaders(null)
  }
  const onclickBack = () => {
    if (id) {
      window.location.href = `/import/configurations/${id}`;
    } else {
      setStep(step - 1);
    }
  }
  const onclickNext = () => {
    setStep(step + 1)
  }
  const onSelectImportType = (selectedOption) => {
    if (selectedOption) {
      setImportType(selectedOption.value)
      setStep(1)
    }
    // alert(JSON.stringify(selectedOption))
  };
  const validate = (values) => {
    let errors = {};
    if(step === 1) 
    {
      if (!importType) {
        errors.import_type = "Please select import type";
      }
      if (!csvFile) {
        errors.import_file = "Csv file is required";
      }
    }
    else if(step === 2) 
    {
      // if(values.hasOwnProperty('fieldsToMap'))
      // {
      //   errors['fieldsToMap']['ProgramID'] = 'Some error';
      // }
      // console.log(errors)
    }
    // alert(JSON.stringify(values))
    return errors;
  }

  const onSubmitStep1 = values => {
    let data = new FormData();
    const prefix = importType.toLowerCase().substring(0, importType.length - 1)
    data.append('upload-file', csvFile)
    const url = `/organization/${organization.id}/${prefix}importheaders`
    // console.log(url)
    axios
    .post(url, data, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    }
    )
    .then((res) => {
      if (!isValidResponse(res.data)) {
        flashError(dispatch, "Cannot read or invalid CSV file");
        return;
      }
      // console.log(res.data)
      setImportHeaders(res.data)
      setStep(2)
    })
    .catch((error) => {
        console.log(error)
    //   const errors = error.response.data.errors;
    //   flashError(dispatch, errors);
    });
  }

  const onSubmitStep2 = values => {

    const isSaveSettings = !!values.isSaveSettings;

    if( !values || !importHeaders || !values.hasOwnProperty("fieldsToMap") || (!id && !(csvFile instanceof File)))
    {
      flashError(dispatch, "Invalid data found")
      setSaveSettings(false);
      return
    }

    const formFields = values.fieldsToMap;

    let newFormFields = {}
    for (const [formRequest, headerFieldsToMap] of Object.entries(importHeaders.fieldsToMap))
    {
      newFormFields[formRequest] = {}
      for (const [fieldName] of Object.entries(headerFieldsToMap))
      {
        for(const [formFieldName, formFieldValue] of Object.entries(formFields) )
        {
          if( formFieldValue){
            let tmpFormRequest = formFieldValue.value.slice(0, formRequest.length);
            let tmpFormFieldValue = formFieldValue.value.slice(formRequest.length);
            if( tmpFormRequest && tmpFormFieldValue && tmpFormFieldValue === fieldName)
            {
              newFormFields[tmpFormRequest][fieldName] = formFieldName;
            }
          }
        }
      }
    }
    let type = '';
    let setupsFields = {};
    if(values.hasOwnProperty("setups"))
    {
        const setups = values['setups'];
        Object.keys(setups).map( (formRequest) => {
            setupsFields[formRequest] = {}
            const fields = setups[formRequest];
            if( Object.keys(fields).length > 0 )
            {
                Object.keys(fields).map( (field) => {
                  if (field === 'type'){
                    type = fields[field].value;
                  }
                    if (fields[field]){
                      setupsFields[formRequest][field]= fields[field].value
                    }
                })
            }
        })
    }

    console.log('[ImportForm] rootProgramId:', rootProgramId, 'isSaveSettings:', isSaveSettings);
    let data = new FormData();
    if(id){
      data.append('id', id)
    }
    data.append('name', values.name || '');
    if(csvImportSettingId){
      data.append('csv_import_setting_id', csvImportSettingId);
    }
    if(rootProgramId){
      data.append('root_program_id', rootProgramId);
    }

    if (csvFile instanceof File) {
      data.append('upload-file', csvFile);
    }
    data.append('fieldsToMap', JSON.stringify(newFormFields))
    if( Object.keys(setupsFields).length > 0){
        data.append('setups', JSON.stringify(setupsFields))
    }

    const prefix = importType.toLowerCase().substring(0, importType.length - 1)
    let url = `/organization/${organization.id}/${prefix}import`
    if (isSaveSettings){
      url = `/organization/${organization.id}/csv-import-setting`
    }

    axios
    .post(url, data, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log('[ImportForm] response:', res.data, 'isSaveSettings:', isSaveSettings);
      if ( res.data?.message )
      {
        flashSuccess(dispatch, "Import request added to queue. You will be notified when it is processed.");
        reset();
      }
      if (isSaveSettings){
        if ( res.data?.success )
        {
          setCsvImportSettingId(res.data.csvImportSetting.id);
          flashSuccess(dispatch, "Settings successfully saved");
          setSaveSettings(false);
        }
      }
    })
    .catch((error) => {
      const errors = error.response.data.errors;
      setError(errors)
      setSaveSettings(false)
    //   alert(JSON.stringify(errors))
      flashError(dispatch, "There were errors. Scroll down the page to view.");
    });
    // return newFormFields;
  }

  const onSubmit = values => {
    if( step === 1 ) {
      onSubmitStep1( values )
    }
    else if( step === 2 )
    {
      onSubmitStep2(values)
    }
  }

  config = { ...config, ...{ roles } }

  return (
  <>
  {isUploadModalOpen && configForUpload && (
    <UploadModal
      organization={organization}
      isOpen={isUploadModalOpen}
      toggle={() => setUploadModalOpen(false)}
      setOpen={setUploadModalOpen}
      config={configForUpload}
      theme={theme || {className: ''}}
      rtl={rtl || {direction: 'ltr'}}
    />
  )}
  <Container className="dashboard">
    <Row>
    <Col md={12}>
    <Card>
      <CardBody style={{display:'flex'}}>

        <Form
          onSubmit={onSubmit}
          validate={validate}
          initialValues={{
            import_type: importType,
            import_file: csvFile,
            name: importHeaders?.name || ''
          }}
        >
          {({ handleSubmit, form, submitting, pristine, values }) => (
            <form className="form" onSubmit={handleSubmit}>
              <Row>
                <Col md="8" lg="8" xl="8">
                  {step === 0 &&
                    <div>
                      <Field name={config.importType.name}
                        parse={
                          (value) => {
                            onSelectImportType(value)
                            return value
                          }
                        }
                      >
                        {({ input, meta }) => (
                          <div className="form__form-group">
                            <h4 className='mb-4'>{config.importType.label}</h4>
                            <div className="form__form-group-field">
                              <div className="form__form-group-row">
                                <Select
                                  options={config.importType.options}
                                  // clearable={false}
                                  className="react-select"
                                  placeholder={importType ? importType : config.importType.placeholder}
                                  classNamePrefix="react-select"
                                  {...input}
                                />
                                {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                              </div>
                              <div className="form__form-group-row">
                                {/* <Button className="btn btn-primary btn-sm" color="#ffffff" disabled={!importType} onClick={onclickNext} style={{margin: 'auto auto auto 10px'}}>GO</Button> */}
                              </div>
                            </div>
                          </div>
                        )}
                      </Field>
                    </div>}
                  {step === 1 && <FormStep1 {...{ config, setStep, csvFile, onSelectCsvFile, onclickBack, onclickNext, importHeaders }} />}
                  {step === 2 && <FormStep2 {...{ config, onclickBack, importHeaders, isValidResponse, setSaveSettings, saveSettings, handleSubmit, rootPrograms, rootProgramId, setRootProgramId, onClickImport: configForUpload ? () => setUploadModalOpen(true) : null, configId: id || null }} />}
                  {error && <ErrorComponentRaw error={error} />}

                  {/*<pre>{JSON.stringify(values, 0, 2)}</pre>*/}

                </Col>
              </Row>
            </form>
          )}
        </Form>
      </CardBody>
      </Card>
      </Col>
    </Row>
  </Container>
  </>
  )
}

const ErrorComponent = ({error}) => {
  return (
    <div className=''>
      <h4 className='mb-2'>Import Errors</h4>
      <div className='p-3'>
        <ul className=''>
            {
              Object.entries(error).map( (a) => (
                <li className='text-danger'>{a[0]}
                  <ul>
                  {
                    Object.entries(a[1]).map( (b) => (
                      <>
                        {
                          Object.entries(b[1]).map( (c) => (
                            <li>{c[0]}
                              <ul>
                                {
                                  Object.keys(c[1]).map( (d, i) => (
                                    <li>{d}
                                      <ul>
                                        {
                                          c[1][d].map( (e, i) =>(
                                            <li>{e}</li>
                                          ))
                                        }
                                      </ul>
                                    </li>
                                  ))
                                }
                              </ul>
                            </li>
                          ))
                        }
                      </>
                    ))
                  }
                  </ul>
                </li>
              ))
            }
        </ul>
      </div>
    </div>
  )
}

const ErrorComponentRaw = ({error}) => {
    return (
        <div className=''>
            <h4 className='mb-2'>Import Errors</h4>
            <div className='p-3 text-danger'>
                {JSON.stringify(error)}
            </div>
        </div>
    )
}

export default withRouter(connect((state) => ({
  organization: state.organization,
  theme: state.theme,
  rtl: state.rtl,
}))(ImportForm));

// {
//   
//   )
// )
